import { renderPage } from '../../domain/itinerary/itinerary-results.page'
import { PARAM_REDIRECT } from '../../domain/router/queryParameters.constants'
import { isPagelessRoute } from '../../domain/router/routeUtils'
import { navigateTo } from '../../store/history/history.actions'
import { hasFromToChanged } from '../../store/history/history.itinerary.utils'
import { selectIsItineraryUniverse } from '../../store/history/history.selectors'
import {
  compute,
  setItinerarySortOptionFromQueryParams,
  setRouteFromParams,
  setStepFromParams
} from '../../store/itinerary/itinerary.actions'
import { selectActiveSort } from '../../store/itinerary/itinerary.selectors'
import { resetItinerary, setRoadbookTimestamp, setStepIdx } from '../../store/itinerary/itinerarySlice'
import { setItineraryTimeOptionsFromQueryParams } from '../../store/itineraryOptions/itineraryOptions.actions'
import {
  ROUTE_ITINERARY_COMPUTING,
  ROUTE_ITINERARY_COMPUTING_BY_MODE,
  ROUTE_ITINERARY_OPTIONS_DIALOG,
  ROUTE_ITINERARY_RESULTS_BY_PROVIDER,
  ROUTE_ITINERARY_RESULTS_BY_ROUTE,
  ROUTE_ITINERARY_TIME_OPTIONS_DIALOG
} from '../index'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ params, avoidRefetchingPageData, store: { dispatch, getState }, routeContext }) => {
  const { from, to, provider, routeId, mode } = params
  setStepFromParams({ from, to })(dispatch, getState)
  setRouteFromParams({ mode, provider, routeId })(dispatch, getState)

  const { prevRoute, nextRoute, action } = routeContext || {}

  const prevRouteIsNotItineraryOptions = prevRoute?.route !== ROUTE_ITINERARY_OPTIONS_DIALOG
  const prevRouteIsNotItineraryTimeOptions = prevRoute?.route !== ROUTE_ITINERARY_TIME_OPTIONS_DIALOG

  if (prevRouteIsNotItineraryTimeOptions) {
    // URL can be called with ?arrivalDateTime=yyyy-mm-ddThh:mm or ?departureDateTime=yyyy-mm-ddThh:mm
    setItineraryTimeOptionsFromQueryParams(routeContext.query)(dispatch, getState)
  }
  if (!selectActiveSort(getState())) {
    // URL can be called with ?sort=SORT_TYPES
    setItinerarySortOptionFromQueryParams(routeContext.query)(dispatch, getState)
  }

  dispatch(setStepIdx(undefined))
  if (avoidRefetchingPageData) return Promise.resolve()

  if (action === 'POP') {
    if (hasFromToChanged({ prevRoute, nextRoute })) {
      setStepFromParams({ from, to }, { force: !isPagelessRoute(prevRoute.route) })(dispatch, getState)
    }
    if (prevRouteIsNotItineraryOptions && prevRouteIsNotItineraryTimeOptions) {
      return Promise.resolve()
    }
  }

  return compute()(dispatch, getState).then(() => {
    const {
      history: { route }
    } = getState()
    dispatch(setRoadbookTimestamp())
    if (
      route === ROUTE_ITINERARY_RESULTS_BY_PROVIDER ||
      route === ROUTE_ITINERARY_COMPUTING ||
      route === ROUTE_ITINERARY_COMPUTING_BY_MODE
    ) {
      return navigateTo({
        route: ROUTE_ITINERARY_RESULTS_BY_ROUTE,
        routeOptions: {
          avoidDispatchingAnyPageAction: true,
          ...(routeContext.query?.get(PARAM_REDIRECT) && {
            query: { [PARAM_REDIRECT]: routeContext.query?.get(PARAM_REDIRECT) }
          })
        }
      })(dispatch, getState)
    }
  })
}

export const onRouteLeave = ({ routeContext }) => {
  const {
    store: { dispatch, getState }
  } = routeContext
  if (!selectIsItineraryUniverse(getState())) {
    dispatch(resetItinerary())
  }
}

export default handleRouteLoading({ onRouteEnter, renderPage, onRouteLeave })
